var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 1.83334C5.94615 1.83334 1.83398 5.9455 1.83398 11V14.7978C1.83398 15.7364 2.65623 16.5 3.66732 16.5H4.58398C4.8271 16.5 5.06026 16.4034 5.23217 16.2315C5.40407 16.0596 5.50065 15.8265 5.50065 15.5833V10.8689C5.50065 10.6258 5.40407 10.3926 5.23217 10.2207C5.06026 10.0488 4.8271 9.95225 4.58398 9.95225H3.75165C4.26132 6.40475 7.31382 3.66667 11.0007 3.66667C14.6875 3.66667 17.74 6.40475 18.2497 9.95225H17.4173C17.1742 9.95225 16.941 10.0488 16.7691 10.2207C16.5972 10.3926 16.5007 10.6258 16.5007 10.8689V16.5C16.5007 17.5111 15.6784 18.3333 14.6673 18.3333H12.834V17.4167H9.16732V20.1667H14.6673C16.6895 20.1667 18.334 18.5222 18.334 16.5C19.3451 16.5 20.1673 15.7364 20.1673 14.7978V11C20.1673 5.9455 16.0552 1.83334 11.0007 1.83334Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.abb15969faebca19f61d1ad115691575.svg";
export { ForwardRef as ReactComponent };